// for add employee

export const RESET_ADD_EMPLOYEE = "reset_add_employee";
export const ADD_EMPLOYEE = "add_employee";
export const ADD_EMPLOYEE_SUCCESS = "add_employee_success";
export const ADD_EMPLOYEE_FAILURE = "add_employee_failure";
